// This file was automatically generated from print.bulkletter.html.
// Please don't edit this file by hand.

goog.provide('el8.template.print.bulkLetter');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.print');
goog.require('el8.template.ptdata.patients');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.bulkLetter.content = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  var recipientList12328 = opt_data.recipients;
  var recipientListLen12328 = recipientList12328.length;
  for (var recipientIndex12328 = 0; recipientIndex12328 < recipientListLen12328; recipientIndex12328++) {
    var recipientData12328 = recipientList12328[recipientIndex12328];
    if (recipientData12328.patientAddress) {
      output.append('<div class="pageWrap pageBreak relative"><div class="letterMailingWindow"><div><div>');
      el8.template.ptdata.patients.displayName(recipientData12328.patient, output);
      output.append('</div><div>', soy.$$escapeHtml(recipientData12328.patientAddress.address), '</div>', (recipientData12328.patientAddress.suite) ? '<div>' + soy.$$escapeHtml(recipientData12328.patientAddress.suite) + '</div>' : '', '<div>', (recipientData12328.patientAddress.city) ? ' ' + soy.$$escapeHtml(recipientData12328.patientAddress.city) + ',' : '', (recipientData12328.patientAddress.state) ? ' ' + soy.$$escapeHtml(recipientData12328.patientAddress.state) : '', (recipientData12328.patientAddress.zip) ? ' ' + soy.$$escapeHtml(recipientData12328.patientAddress.zip) : '', '</div></div></div></div>');
    }
    output.append('<div class="pageWrap pageBreak">');
    if (el8Globals.PRINT_HEADER) {
      el8.template.print.header({practice: opt_data.practice}, output);
    }
    output.append('<div class="letterBody">');
    el8.template.print.bulkLetter.letterHeader({date: opt_data.date, patient: recipientData12328.patient, primaryPhysicianName: recipientData12328.primaryPhysicianName, signedBy: opt_data.signedBy, subject: opt_data.subject, patientAddress: recipientData12328.patientAddress}, output);
    output.append('<p class="el8Preserve">', (opt_data.body) ? soy.$$escapeHtml(opt_data.body) : '(No Message Body)', '</p></div></div>');
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.print.bulkLetter.letterHeader = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<table class="letterOpening" width="100%" border="0" cellspacing="0" cellpadding="0"><tr><td class="pt10" width="100%">', (soy.$$escapeHtml(opt_data.date)? el8.service.tz.soyLongMonthDay(soy.$$escapeHtml(opt_data.date)) : ''), ', ', (soy.$$escapeHtml(opt_data.date)? el8.service.tz.soyYear(soy.$$escapeHtml(opt_data.date)) : ''), '</td></tr><tr><td class="pt20" width="100%">To: <span class="el8Bold">');
  el8.template.ptdata.patients.displayName(opt_data.patient, output);
  output.append('</span><br>');
  if (opt_data.patientAddress) {
    output.append('<span>');
    el8.template.ptdata.patients.mailingAddress(opt_data.patientAddress, output);
    output.append('</span><br>');
  }
  output.append((opt_data.primaryPhysicianName) ? 'From: <span class="el8Bold">The office of ' + soy.$$escapeHtml(opt_data.primaryPhysicianName) + '</span>' : 'From: <span class="el8Bold">' + soy.$$escapeHtml(opt_data.signedBy) + '</span>', '</td></tr><tr><td class="pt10" width="100%">Subject: <span class="el8Bold">', (opt_data.subject) ? soy.$$escapeHtml(opt_data.subject) : '(No Subject)', '</span></td></tr></table>');
  if (!opt_sb) return output.toString();
};
